import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import CustomCircularProgress from "../../Loading/CustomCircularProgress"
import { getContactsGroups } from "../../../endpoints"
import CardContactGroup from "./CardContactGroup.jsx";

const ModalAsignarContactos = ({
  closeModalAsignarContactos,
  stopPropagation,
  asesorId,
  refresh,
  setRefresh
}) => {
  const [contactsGroup, setContactsGroup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectFilter, setSelectFilter] = useState("Asignados");

  const getContactsGroupsAsync = async () => {
    setLoading(true)
    getContactsGroups().then((res) => {
      if (res.status === 200) {
        setContactsGroup(res.data)
        console.log(res.data)

        setLoading(false)
      } else {
        setLoading(false)
      }
    })
  }
  useEffect(() => {
    getContactsGroupsAsync()
  }, [])


  const handleCancelar = () => {
    closeModalAsignarContactos();
  };
  const changeSelectFilter = (select) => {
    setSelectFilter(select)
  }
  useEffect(() => {
    console.log(selectFilter)
  }, [selectFilter])
  return (
    <ModalWrapper onClick={handleCancelar}>
      <DivColumn onClick={stopPropagation}>
        <ContentSeccions>
          <BtnFilter style={{
            backgroundColor: selectFilter === "Sin Asignar" ? "#003049" : "#7f7f7f",

          }}
            onClick={() => changeSelectFilter("Sin Asignar")}
          >
            Sin Asignar
          </BtnFilter>
          <LineaDivisoria />
          <BtnFilter style={{
            backgroundColor: selectFilter === "Asignados" ? "#003049" : "#7f7f7f",
          }}
            onClick={() => changeSelectFilter("Asignados")}
          >
            Asignados
          </BtnFilter>
        </ContentSeccions>
        {
          loading ?
            <CustomCircularProgress size={35} />
            :
            <ScrollContainer>
              {
                loading === false && contactsGroup.length > 0 ?
                  <>
                    {contactsGroup.map((group, index) => (
                      <CardContactGroup
                        key={group.id}
                        group={group}
                        userId={asesorId}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        getContactsGroupsAsync={getContactsGroupsAsync}
                      />

                    ))}
                  </> :
                  <span>No se encontraron Grupos de contantos.</span>
              }
            </ScrollContainer>
        }

      </DivColumn>
    </ModalWrapper>
  );
};

export default ModalAsignarContactos;
const LineaDivisoria = styled.div`
  height:40px;
  width:1px;
  background-color:#fdfcff;
`;
const BtnFilter = styled.div`
  height:40px;
  width:-webkit-fill-available;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #fdfcff;
    text-aling:center;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor:pointer;
    // background-color: #003049;
    &:hover{
      opacity:0.7;
   
    }
`;
const ContentSeccions = styled.div`
  height:40px;
  width:-webkit-fill-available;
  border-bottom: solid 2px #003049;
  display:flex;
  flex-direction: row;
  align-items: center;

`;
const ScrollContainer = styled.div`
width: -webkit-fill-available;
height: auto;
max-height: calc(100vh - 31vh) !important;
overflow-y: auto;
overflow-x: hidden;
gap: 0px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
scroll-behavior: smooth;
padding: 8px 0px 0px 0px;
// border-top: 2px solid #003049;
justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
const DivColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 40vw;
    margin: 0px 0% 0% 0%;
    padding: 0px 0px 0px 0px;
    border-radius: 8px;
    background-color: #FFFFFF;
    gap: 0px;
    // min-height: 90vh;
    heigth: auto;
    max-height: 90vh;
    min-height: 40vh;
    overflow-y: auto;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
    @media only screen and (min-width:0px) and (max-width:1100px){
      width:95%;
    }
`;